export const getExcelTemplateFilename = (title: string, date = new Date()) => {
  const stamp = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`;
  const tableName = title
    .trim()
    .replace(/\s+details$/i, '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]/g, '');
  return `${stamp}_${tableName}.xlsx`;
};
